const ComingSoon = () => {
    return (
        <div>Comming Soon</div>
    )
};

export default ComingSoon;